import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class ContractorAvailableProject {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  name!: string;
}

export type OrderGetContractorAvailableProjects = Array<ContractorAvailableProject>;
